import * as React from 'react';
import { IAppHostProps } from '../meta-os-app-container.interface';

const baseStyles = (): React.CSSProperties => ({
  height: '100%',
  width: '100%',
  border: 0,
  flex: 1,
});

const loadingStyles = (): React.CSSProperties => ({
  display: 'none',
});

export const AppHostIframe = ({
  sdkHost,
  contentUrl,
  frameContext,
  appDefinition,
  title,
  isLoading,
  userClickTime,
}: IAppHostProps) => {
  const sandBoxProperties =
    'allow-forms allow-popups allow-popups-to-escape-sandbox allow-pointer-lock allow-scripts allow-same-origin allow-modals';
  const iframeRef = React.useRef<HTMLIFrameElement | null>(null);

  React.useEffect(() => {
    (async () => {
      await sdkHost.setFrameAndLoadOrigin(iframeRef.current, contentUrl, appDefinition, userClickTime);
    })();
  }, [sdkHost, iframeRef, contentUrl, frameContext, appDefinition]);
  return (
    <iframe
      data-tid="app-host-iframe"
      ref={iframeRef}
      style={isLoading ? { ...loadingStyles() } : { ...baseStyles() }}
      sandbox={sandBoxProperties}
      title={title}
    />
  );
};
